
import { format } from 'path';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getEorderTemplateSet, eorderTemplateSet } from '@/api/system';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'SystemTemplateSetting',
  components: {

  }
})
export default class extends Vue {
  private customItems:any = {
    title: '巡检工作单',
    order_num: '编号',
    customer_company_name: '客户名称',
    name: '联系人',
    address: '联系地址',
    engineer_name: '工程师',
    start_time: '开始时间',
    end_time: '结束时间',
    event_title: '维护保养',
    device_info: '设备信息',
    device_name: '设备名称',
    device_sn: 'sn',
    device_number: '设备编号',
    device_brand: '品牌',
    device_product: '类型',
    device_model: '型号',
    device_address: '设备地址',
    event_name: '项目',
    check_name: '巡检项',
    check_state: '状态',
    check_value: '值',
    check_text: '描述',
    check_statement: '说明',
    parts_title: '更换配件',
    parts_name: '配件名称',
    parts_model: '配件型号',
    parts_amount: '使用数量',
    parts_price: '配件金额',
    parts_engineer: '工程师',
    price_title: '费用',
    price_name: '收费项目',
    price_num: '收费金额',
    money_title: '金额',
    money_parts: '配件',
    money_price: '费用',
    money_count: '总计',
    remark_title: '备注',
    customer_sign_title: '客户签字'
  }
  private tableTitle = UserModule.getCompanyName;

  created() {
    this.getSet();
  }

  getSet() {
    let params = {
      company_id: UserModule.getCompanyId
    };
    getEorderTemplateSet(params).then(res => {
      if (res.data) {
        this.customItems = res.data;
        this.customItems = {
          title: res.data.title ? res.data.title : '巡检工作单',
          order_num: res.data.order_num ? res.data.order_num : '编号',
          customer_company_name: res.data.customer_company_name ? res.data.customer_company_name : '客户名称',
          name: res.data.name ? res.data.name : '联系人',
          address: res.data.address ? res.data.address : '联系地址',
          engineer_name: res.data.engineer_name ? res.data.engineer_name : '工程师',
          start_time: res.data.start_time ? res.data.start_time : '开始时间',
          end_time: res.data.end_time ? res.data.end_time : '结束时间',
          event_title: res.data.event_title ? res.data.event_title : '维护保养',
          device_info: res.data.device_info ? res.data.device_info : '设备信息',
          device_name: res.data.device_name ? res.data.device_name : '设备名称',
          device_sn: res.data.device_sn ? res.data.device_sn : 'sn',
          device_number: res.data.device_number ? res.data.device_number : '设备编号',
          device_brand: res.data.device_brand ? res.data.device_brand : '品牌',
          device_product: res.data.device_product ? res.data.device_product : '类型',
          device_model: res.data.device_model ? res.data.device_model : '型号',
          device_address: res.data.device_address ? res.data.device_address : '设备地址',
          event_name: res.data.event_name ? res.data.event_name : '项目',
          check_name: res.data.check_name ? res.data.check_name : '巡检项',
          check_state: res.data.check_state ? res.data.check_state : '状态',
          check_value: res.data.check_value ? res.data.check_value : '值',
          check_text: res.data.check_text ? res.data.check_text : '描述',
          check_statement: res.data.check_statement ? res.data.check_statement : '说明',
          parts_title: res.data.parts_title ? res.data.parts_title : '更换配件',
          parts_name: res.data.parts_name ? res.data.parts_name : '配件名称',
          parts_model: res.data.parts_model ? res.data.parts_model : '配件型号',
          parts_amount: res.data.parts_amount ? res.data.parts_amount : '使用数量',
          parts_price: res.data.parts_price ? res.data.parts_price : '配件金额',
          parts_engineer: res.data.parts_engineer ? res.data.parts_engineer : '工程师',
          price_title: res.data.price_title ? res.data.price_title : '费用',
          price_name: res.data.price_name ? res.data.price_name : '收费项目',
          price_num: res.data.price_num ? res.data.price_num : '收费金额',
          money_title: res.data.money_title ? res.data.money_title : '金额',
          money_parts: res.data.money_parts ? res.data.money_parts : '配件',
          money_price: res.data.money_price ? res.data.money_price : '费用',
          money_count: res.data.money_count ? res.data.money_count : '总计',
          remark_title: res.data.remark_title ? res.data.remark_title : '备注',
          customer_sign_title: res.data.customer_sign_title ? res.data.customer_sign_title : '客户签字'
        };
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  saveHandle() {
    let params = {
      company_id: UserModule.getCompanyId,
      ...this.customItems
    };
    eorderTemplateSet(params).then(res => {
      this.$notify({
        title: '提示',
        message: '成功',
        type: 'success'
      });
    }).catch(err => {
      let msg = err.msg;
    });
  }
}

